import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsBusbarsIP, OptionsConnectedDef, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-busbars',
  templateUrl: './ds-busbars.component.html',
  styleUrls: ['./ds-busbars.component.css']
})
export class DsBusbarsComponent implements OnInit, OnChanges {
  
    @Input() dsBusbarObj: DsBusbarsIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock

  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsBusbarObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }

  cachedPhIdentification: any = {};
  filterPhIdentification() {
    let _id = this.dsBusbarObj.parentSORef.marketingIP.ordertypeId;
    if (this.cachedPhIdentification[_id] != null) {
      return this.cachedPhIdentification[_id];
    }
    this.cachedPhIdentification[_id] = this._dataService.phaseIdentification.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedPhIdentification[_id];
    if (this.cachedPhIdentification[_id] != null) {
      return this.cachedPhIdentification[_id];
    }
    var _result = !this._dataService.isGeneralPhaseIdentification(_id);
    this.cachedPhIdentification[_id] = _result;
    return _result;
  }

  cachedEarthSize: any = {};
  filterEarthSize() {
    let _id ="";
    let _shrtCurr = this._dataService.extractNumberkA(this.dsBusbarObj.parentDSRef.dsGeneralIP.shortTimeCurrRating);
    if(_shrtCurr != null && _shrtCurr <= 25){
      _id = "<=25";
    }
    else if(_shrtCurr != null && _shrtCurr > 25){
      _id = ">25";
    }
    if (this.cachedEarthSize[_id] != null) {
      return this.cachedEarthSize[_id];
    }
    this.cachedEarthSize[_id] = this._dataService.earthBBSize.filter((_obj: OptionsConnectedDef) => {
      if ((_obj.connectedOptionId.length == 0) || _obj.connectedOptionId.indexOf(_id) >= 0) {
        return true;
      }
      return false;
    });
    // return this.cachedEarthSize[_shrtCurr];
    if (this.cachedEarthSize[_id] != null) {
      return this.cachedEarthSize[_id];
    }
  
    var _result = !this._dataService.isGeneralEarthBBSize(_id);
    this.cachedEarthSize[_id] = _result;
    return _result;
  }

  
  sectionNoteChangePM(_event: any) {
    this.dsBusbarObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsBusbarObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsBusbarObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
        if(this.updateDatasheet){
          this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
              (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
        }
      }
      reloadData(){
        if(this.updateDatasheet){
          this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
        }
      }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    // PM access group
    if (this.hasAccessPM) {
      _validList.push(
        new ValidationItem("Busbar System", !!this.dsBusbarObj.busBarSystem, " required to save Datasheet."),
        new ValidationItem("Main Busbar and Droppers", !!this.dsBusbarObj.mainBusDropper, " required to save Datasheet."),
        new ValidationItem("PM Note", !!this.dsBusbarObj.sectionNotePM, " required to save Datasheet.")
      );
    }

    // ME access group
    if (this.hasAccessME) {
      _validList.push(
        new ValidationItem("Feeder Connections", !!this.dsBusbarObj.feederConnect, " required to save Datasheet."),
        new ValidationItem("HT Sleeves Make", !!this.dsBusbarObj.htSleevesMake, " required to save Datasheet."),
        new ValidationItem("Phase Identification", !!this.dsBusbarObj.phaseIdentification, " required to save Datasheet."),
        new ValidationItem("Earth Bus Bar Size", !!this.dsBusbarObj.earthBBSize, " required to save Datasheet."),
        new ValidationItem("ME Note", !!this.dsBusbarObj.sectionNoteME, " required to save Datasheet.")
      );
      if (this.dsBusbarObj.isEarthSizeSpecReqApplicable) {
        _validList.push(new ValidationItem("Earth Bus Bar Size Detail", !!this.dsBusbarObj.earthBBSize_2, " required to save Datasheet."));
      }
    }

    // EE access group
    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("EE Note", !!this.dsBusbarObj.sectionNoteEE, " required to save Datasheet.")
      );
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);

    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  saveSOValidation(): boolean {
    // PM critical fields
    if (this.hasAccessPM) {
      if (!this.dsBusbarObj.busBarSystem || !this.dsBusbarObj.mainBusDropper || !this.dsBusbarObj.sectionNotePM) {
        return false;
      }
    }

    // ME critical fields
    if (this.hasAccessME) {
      if (!this.dsBusbarObj.feederConnect || !this.dsBusbarObj.htSleevesMake ||
        !this.dsBusbarObj.phaseIdentification || !this.dsBusbarObj.earthBBSize ||
        !this.dsBusbarObj.sectionNoteME) {
        return false;
      }
      if (this.dsBusbarObj.isEarthSizeSpecReqApplicable) {
        if (!this.dsBusbarObj.earthBBSize_2) {
          return false;
        }
      }
    }

    // EE critical fields
    if (this.hasAccessEE) {
      if (!this.dsBusbarObj.sectionNoteEE) {
        return false;
      }
    }
    return true;
  }

}

